<template>
    <div>
        <tv-channels-section
            v-if="channels.length > 0"
            :header-class="headerClass"
            :header-text="lang('Kanaler','Channels')"
            :channels="channels"
            :tooltip-text="translation('tv_tooltip_channels')"
        />
        <tv-channels-section
            v-if="tvPackage.play_channels && tvPackage.play_channels.length > 0"
            :header-class="headerClass"
            :header-text="tvPackage.play_channels && tvPackage.play_channels.length > 1 ? lang('Playkanaler','Play channels') : lang('Playkanal','Play channel')"
            :channels="tvPackage.play_channels"
            :tooltip-text="translation('tv_tooltip_play_channels')"
        />
        <tv-channels-section
            v-if="tvPackage.is_flex && tvPackage.flex_channels.length > 0"
            :header-class="headerClass"
            :header-text="lang('Valbara kanaler för Flex', 'Selectable channels for Flex')"
            :channels="tvPackage.flex_channels"
            :tooltip-text="translation('tv_tooltip_flex_channels')"
        />
    </div>
</template>

<script>
    import TvChannelsSection from './TvChannelsSection';

    export default {
        components: {
            TvChannelsSection,
        },
        props: {
            tvPackage: {
                type: Object,
                required: true,
            },
            headerClass: {
                type: String,
                default: 'h4',
            },
        },
        computed: {
            channels() {
                return this.tvPackage.sd_channels.concat(this.tvPackage.hd_channels).sort((a, b) => {
                    if (! a.ataio_data || ! b.ataio_data) {
                        return 0;
                    }

                    if (a.ataio_data.Order < b.ataio_data.Order) {
                        return -1;
                    }
                    if (a.ataio_data.Order > b.ataio_data.Order) {
                        return 1;
                    }

                    return 0;
                });
            },
        },
    };
</script>
